import React, { FC } from 'react';

import Online from '@/components/online/Online';
import { Medium } from '@/constants/mediums';

const WasteOnlinePage: FC = () => {
  return <Online medium={Medium.waste} allowMinuteData={false} />;
};

export default WasteOnlinePage;
